import $ from 'jquery'; // Ensure jQuery is imported


export function readMore() {
    $('.content-block--readmore').each(function(){
        let readmore = $(this).find('.read-more-btn');
        let readless = $(this).find('.read-less-btn');
        let extendedContent =  $(this).find('.content-extended');
        if(readmore.length){
            readmore.on('click' , function(){
                extendedContent.slideDown();
                readless.show();
                readmore.hide();
            });
            readless.on('click' , function(){
                extendedContent.slideUp();
                readless.hide();
                readmore.show();
            });
        }
    });
}
